<header class="event-networking-header flex align-items-center justify-content-between">
  <div class="logo ml-3 md:ml-5 flex align-items-center h-full">
    <a href="https://www.femmepalette.com/"><img class="logo flex" src="assets/FP-logo.png" alt="FP logo" /></a>
  </div>
</header>

<main class="event-networking-page">
  <div class="event-networking-page__inner text-center md:text-left md:px-6 py-5 md:py-6">
    <ng-container *ngIf="loading">
      <p-progressSpinner></p-progressSpinner>
    </ng-container>

    <p *ngIf="errorMessage" class="p-error m-0">{{ errorMessage }}</p>

    <ng-container *ngIf="!loading && !errorMessage && eventData">
      <div class="flex flex-column md:flex-row md:align-items-start md:justify-content-between gap-4 md:mb-5 mb-2">
        <h1 class="event-networking-page__title">{{ pageTitle }} Event Participants</h1>
        <div class="flex gap-3 event-networking-page__action-buttons-wrap" *ngIf="interestOptions.length > 0">
          <p-select
            inputId="interest_filter"
            [(ngModel)]="selectedInterest"
            [options]="interestOptions"
            optionLabel="label"
            optionValue="value"
            [showClear]="true"
            [placeholder]="'EVENT_NETWORKING_PUBLIC.FILTER_INTEREST' | translate"
            styleClass="w-full md:w-19rem"
            (onChange)="onInterestChange()"
          ></p-select>
          <p-button
            styleClass="p-button-success md:w-9rem w-full"
            [label]="'EVENT_NETWORKING_PUBLIC.TAKE_THE_SURVEY' | translate"
            (click)="onTakeTheSurvey()"
          ></p-button>
        </div>
      </div>
      <div *ngIf="totalFiltered === 0" class="flex flex-column align-items-center justify-content-center gap-4 mt-6">
        <p class="text-color-secondary m-0 text-20">
          {{ 'EVENT_NETWORKING_PUBLIC.NO_PARTICIPANTS' | translate }}
        </p>
        <p-button
          styleClass="widescreen-only p-button-success"
          [label]="'EVENT_NETWORKING_PUBLIC.TAKE_THE_SURVEY' | translate"
          (click)="onTakeTheSurvey()"
        ></p-button>
      </div>

      <div class="grid" *ngIf="totalFiltered > 0">
        <article *ngFor="let p of pagedParticipants" class="col-12 lg:col-6 mb-1 flex">
          <div class="participant-card">
            <div class="participant-card__avatar-wrap">
              <img *ngIf="p.attendee_photo" class="participant-card__avatar" [src]="p.attendee_photo" [alt]="p.attendee_name" />
              <span *ngIf="!p.attendee_photo" class="participant-card__avatar-fallback">
                {{ getInitials(p.attendee_name) }}
              </span>
            </div>
            <div class="participant-card__body">
              <div class="participant-card__identity">
                <div class="participant-card__header-row">
                  <h2 class="participant-card__name m-0 min-w-0">{{ p.attendee_name }}</h2>
                  <ng-container *ngIf="linkedinHref(p) as href; else connectDisabled">
                    <a
                      pButton
                      class="participant-card__connect"
                      [ngClass]="{ 'participant-card__connect--clicked': isLinkedInClicked(p) }"
                      [href]="href"
                      target="_blank"
                      rel="noopener noreferrer"
                      [label]="
                        isLinkedInClicked(p)
                          ? ('EVENT_NETWORKING_PUBLIC.CONNECTED' | translate)
                          : ('EVENT_NETWORKING_PUBLIC.CONNECT' | translate)
                      "
                      (click)="onLinkedInClick(p)"
                    ></a>
                  </ng-container>
                  <ng-template #connectDisabled>
                    <button
                      pButton
                      type="button"
                      class="participant-card__connect"
                      [label]="'EVENT_NETWORKING_PUBLIC.CONNECT' | translate"
                      [disabled]="true"
                    ></button>
                  </ng-template>
                </div>
                <p class="participant-card__role m-0">{{ p.attendee_job_and_company }}</p>
              </div>
              <ng-container *ngIf="interestsList(p) as tags">
                <div class="participant-card__tags" *ngIf="tags.length">
                  <span class="participant-card__tag" *ngFor="let tag of tags">{{ tag }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </article>
      </div>

      <p-paginator
        *ngIf="showPaginator"
        class="event-networking-page__paginator flex justify-content-center mt-4"
        (onPageChange)="onPageChange($event)"
        [first]="first"
        [rows]="pageRows"
        [totalRecords]="totalFiltered"
        [showFirstLastIcon]="false"
      >
        <ng-template pTemplate="previouspagelinkicon">
          <span class="p-paginator-icon">{{ 'EVENT_NETWORKING_PUBLIC.PREVIOUS' | translate }}</span>
        </ng-template>
        <ng-template pTemplate="nextpagelinkicon">
          <span class="p-paginator-icon">{{ 'EVENT_NETWORKING_PUBLIC.NEXT' | translate }}</span>
        </ng-template>
      </p-paginator>
    </ng-container>
  </div>
</main>
